class ProjectSelectorController {
    constructor($scope, ProjectSelectorService) {
        'ngInject';
        this.projects = [];
        this.selected = {};
        this.ProjectSelectorService = ProjectSelectorService;
    }

    $onInit() {
        this.reload();
    }
    onChange(selected) {
        document.location.replace(`${this.gotoUrl}?projectId=${selected.id}&isInConfigArea=${this.isConfig}&actionUrl=${this.actionUrl}`);
    }

    reload() {
        this.ProjectSelectorService.selector().$promise.then((prs) => {
            this.projects = prs;
            if(this.projects.length > 0)
            {
                this.selected = prs.filter(p => p.project.id === (this.selected.id || parseInt(this.currentId)))[0].project;
            }
        });
    }

    groupByGroup(item) {
        return item.group.name;
    }
}

export default ProjectSelectorController;


// WEBPACK FOOTER //
// ../widgets/project-selector/project-selector.controller.js